import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { journalAPI } from '../../services/api';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';
import { fmtMoney } from '../../utils/currency';

const fmt = fmtMoney;

export default function JournalList() {
  const { hasPermission } = useAuth();
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ status: '', startDate: '', endDate: '', search: '' });

  const load = async () => {
    try {
      const data = await journalAPI.list(filters);
      setEntries(data);
    } catch (err) { toast.error(err.message); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  return (
    <div>
      <div className="toolbar">
        <h2>Journal Entries</h2>
        <div className="toolbar-right">
          {hasPermission('journal:create') && (
            <button className="btn btn-primary" onClick={() => navigate('/journal/new')}>+ New Journal Entry</button>
          )}
        </div>
      </div>

      <div className="filters-bar">
        <input className="form-control" placeholder="Search..." value={filters.search} onChange={e => setFilters({...filters, search: e.target.value})} />
        <select className="form-control" value={filters.status} onChange={e => setFilters({...filters, status: e.target.value})}>
          <option value="">All Status</option>
          <option value="Draft">Draft</option>
          <option value="Posted">Posted</option>
          <option value="Voided">Voided</option>
        </select>
        <input type="date" className="form-control" value={filters.startDate} onChange={e => setFilters({...filters, startDate: e.target.value})} />
        <input type="date" className="form-control" value={filters.endDate} onChange={e => setFilters({...filters, endDate: e.target.value})} />
        <button className="btn btn-outline" onClick={load}>Filter</button>
      </div>

      {loading ? <div className="spinner" style={{margin:'40px auto'}} /> : (
        <div className="card">
          <div className="card-body" style={{padding:0}}>
            <table>
              <thead>
                <tr><th>Date</th><th>Entry #</th><th>Description</th><th>Reference</th><th className="text-right">Debit</th><th className="text-right">Credit</th><th>Status</th><th>Source</th></tr>
              </thead>
              <tbody>
                {entries.map(e => (
                  <tr key={e.id} onClick={() => navigate(`/journal/${e.id}`)} style={{cursor:'pointer'}}>
                    <td>{e.entry_date}</td>
                    <td className="font-mono">{e.entry_number}</td>
                    <td>{e.description}</td>
                    <td className="text-muted">{e.reference || '-'}</td>
                    <td className="amount">{fmt(e.total_debit)}</td>
                    <td className="amount">{fmt(e.total_credit)}</td>
                    <td><span className={`badge badge-${e.status?.toLowerCase()}`}>{e.status}</span></td>
                    <td className="text-muted" style={{fontSize:12}}>{e.source_module || 'manual'}</td>
                  </tr>
                ))}
                {entries.length === 0 && <tr><td colSpan={8} className="text-center text-muted" style={{padding:30}}>No journal entries found</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
